import { format } from 'date-fns'
import { Formatters, MonthCaptionProps, useNavigation } from 'react-day-picker'

import { ptBR } from 'date-fns/locale'
import { ChevronLeft, ChevronRight } from 'lucide-react'
import { Typography } from '../../Typography'

/**
 * Custom format week day name
 * @param month Date
 * @param options { locale }
 * @returns ReactNode with dayWeekName
 */
export const formatWeekdayName: Formatters['formatWeekdayName'] = (
  month,
  options,
) => {
  const dayFormated = format(month, 'EEEEEE', {
    locale: options?.locale,
  }).toUpperCase()

  return dayFormated
}

export const CustomCaption = (props: MonthCaptionProps) => {
  const { goToMonth, nextMonth, previousMonth } = useNavigation()

  const monthDescribed = format(props.calendarMonth.date, 'LLLL', {
    locale: ptBR,
  })

  const year = format(props.calendarMonth.date, 'yyyy', { locale: ptBR })

  return (
    <div className="mb-4 flex items-center justify-between">
      <button
        type="button"
        data-testid="calendar_previous_month"
        disabled={!previousMonth}
        onClick={() => previousMonth && goToMonth(previousMonth)}>
        <ChevronLeft size={16} className="text-gray-200" />
      </button>

      <Typography type="bodyOne" className="text-gray-200">
        {`${
          monthDescribed.at(0)?.toUpperCase() + monthDescribed.substring(1)
        } ${year}`}
      </Typography>

      <button
        type="button"
        data-testid="calendar_next_month"
        disabled={!nextMonth}
        onClick={() => nextMonth && goToMonth(nextMonth)}>
        <ChevronRight size={16} className="text-gray-200" />
      </button>
    </div>
  )
}
